export default __webpack_public_path__ + "static/media/icon_user.3c7ceb5e.svg";